import { Injectable, signal, Signal } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GearType } from '../../models/gear-type';
import { Vehicle } from '../../models/vehicle';
import { Validators } from '@softline/ui-core';
import { CustomGearService } from './custom-gear.service';

@Injectable()
export class VehicleService extends CustomGearService<Vehicle> {
  override readonly type: Signal<GearType> = signal('vehicle');
  override readonly title: Signal<string> = signal('Fahrzeug Verwaltung');

  createForm() {
    return new FormGroup({
      id: new FormControl<number | null>(null),
      number: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required()],
      }),
      name: new FormControl<string | null>(null, {
        validators: [Validators.required()],
      }),
      tool: new FormControl<string | null>(null),
      general: new FormGroup({
        licensePlateNumber: new FormControl<string | null>(null),
        usage: new FormControl<object | null>(null),
        firstRegistration: new FormControl<string | null>(null),
      }),
      customerInformation: new FormGroup({
        customer: new FormControl<object | null>(null),
        salesOrganisation: new FormControl<object | null>({
          nonNullable: true,
          validators: [Validators.required()],
        }),
        active: new FormControl<boolean>(true),
      }),
      classification: new FormGroup({
        handoverDate: new FormControl<string | null>(null),
        inspectionType: new FormControl<string | null>(null),
        engineNumber: new FormControl<string | null>(''),
        mainClass: new FormControl<object | null>(null),
        subClass: new FormControl<object | null>(null),
        yearBuilt: new FormControl<string | null>(null),
      }),
      type: new FormGroup({
        euroTaxCode: new FormControl<string | null>(null),
        vehicleType: new FormControl<object | null>(null),
        brand: new FormControl<string | null>(null),
        tradeName: new FormControl<string | null>(null),
        variant: new FormControl<string | null>(null),
        structure: new FormControl<string | null>(null),
      }),
      weight: new FormGroup({
        weight: new FormControl<number | null>(null),
        techTotalWeight: new FormControl<number | null>(null),
        totalWeight: new FormControl<number | null>(null),
        payload: new FormControl<number | null>(null),
        saddleLoad: new FormControl<number | null>(null),
      }),
      axleLoad: new FormGroup({
        axleLoad1: new FormControl<number | null>(null),
        axleLoad2: new FormControl<number | null>(null),
        axleLoad3: new FormControl<number | null>(null),
        axleLoad4: new FormControl<number | null>(null),
        trailerLoadBraked: new FormControl<number | null>(null),
        trailerLoadUnbraked: new FormControl<number | null>(null),
      }),
      motor: new FormGroup({
        motorType: new FormControl<string | null>(null),
        driveType: new FormControl<string | null>('D'), // required
        maxSpeed: new FormControl<number | null>(null),
        engineDisplacement: new FormControl<number | null>(null),
        hp: new FormControl<number | null>(null),
        tireDimension: new FormControl<string | null>(null),
      }),
      archiveKey: new FormControl<object | null>(null),
    });
  }
}
